import { render, staticRenderFns } from "./summaryUser.vue?vue&type=template&id=6d219d5e&"
import script from "./summaryUser.vue?vue&type=script&lang=js&"
export * from "./summaryUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports